import { useCallback, useMemo, useState } from "react";
import { SortDirection, SortObject } from "../../shared/dataGrid/types";
import { PaginationAttributes } from "./types";

const orderBySign = (direction: SortDirection) => {
  return direction === "asc" ? "" : "-";
};

export function usePaginationAttributes(
  initialSort?: SortObject[],
): PaginationAttributes {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState<SortObject[]>(initialSort ?? []);
  const [search, setSearch] = useState<string>("");
  const [selectionModel, setSelectionModel] = useState<string[]>([]);
  const orderBy = useMemo(() => {
    return sort.map((s) => `${orderBySign(s.direction)}${s.key}`).join(",");
  }, [sort]);
  const clearSelection = useCallback(() => setSelectionModel([]), []);
  return {
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    offset: (currentPage - 1) * pageSize,
    sort,
    setSort,
    orderBy,
    search,
    setSearch,
    pageSizeOptions: [10, 25, 50, 100],
    selectionModel,
    setSelectionModel,
    clearSelection,
  };
}
